import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function ForgotPasswordScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('email');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [codeError, setCodeError] = useState('');
  const [resetting, setResetting] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) { setEmailError('Введите email'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) { setEmailError('Некорректный email'); return; }
    setEmailError(''); setLoading(true);
    try {
      await api.auth.forgotPassword({ email: trimmed });
      setStep('code');
    } catch (err) {
      setEmailError(err.detail || 'Нет соединения с сервером');
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (code.length < 6) { setCodeError('Введите код из письма'); return; }
    if (!newPassword) { setCodeError('Введите новый пароль'); return; }
    if (newPassword.length < 6) { setCodeError('Минимум 6 символов'); return; }
    if (newPassword !== confirmPassword) { setCodeError('Пароли не совпадают'); return; }
    setCodeError(''); setResetting(true);
    try {
      await api.auth.resetPassword({ email: email.trim(), code, new_password: newPassword });
      alert('Пароль успешно изменён');
      navigate('/login');
    } catch (err) {
      setCodeError(err.detail || 'Неверный или устаревший код');
    } finally { setResetting(false); }
  };

  if (step === 'code') {
    return (
      <div style={{ padding: 24, minHeight: '100vh' }}>
        <button onClick={() => setStep('email')} style={backBtn}>← Назад</button>
        <h1 style={titleStyle}>Новый пароль</h1>
        <p style={subtitleStyle}>Введите код из письма на <strong style={{ color: 'var(--text)' }}>{email.trim()}</strong></p>
        <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          <label style={labelStyle}>Код из письма</label>
          <input type="text" placeholder="000000" maxLength={6} value={code}
            onChange={e => { setCode(e.target.value.replace(/\D/g, '').slice(0, 6)); setCodeError(''); }}
            style={{ ...inputStyle, fontSize: 24, textAlign: 'center', letterSpacing: 8, borderColor: codeError ? '#FF3B30' : 'var(--border)' }} />
          <label style={labelStyle}>Новый пароль</label>
          <input type="password" placeholder="Минимум 6 символов" value={newPassword}
            onChange={e => { setNewPassword(e.target.value); setCodeError(''); }}
            style={{ ...inputStyle, borderColor: codeError ? '#FF3B30' : 'var(--border)' }} />
          <label style={labelStyle}>Подтвердите пароль</label>
          <input type="password" placeholder="Повторите пароль" value={confirmPassword}
            onChange={e => { setConfirmPassword(e.target.value); setCodeError(''); }}
            style={{ ...inputStyle, borderColor: codeError ? '#FF3B30' : 'var(--border)' }} />
          {codeError && <p style={errorStyle}>⚠ {codeError}</p>}
          <button type="submit" disabled={resetting} style={{ ...btnStyle, opacity: resetting ? 0.6 : 1, marginTop: 24 }}>
            {resetting ? 'Сохранение...' : 'Сохранить пароль'}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: 24, minHeight: '100vh' }}>
      <button onClick={() => navigate('/login')} style={backBtn}>← Назад</button>
      <h1 style={titleStyle}>Забыли пароль?</h1>
      <p style={subtitleStyle}>Введите email — отправим код для сброса пароля</p>
      <form onSubmit={handleSend} style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <label style={labelStyle}>Email</label>
        <input type="email" placeholder="example@mail.ru" autoFocus value={email}
          onChange={e => { setEmail(e.target.value); setEmailError(''); }}
          style={{ ...inputStyle, borderColor: emailError ? '#FF3B30' : 'var(--border)' }} />
        {emailError && <p style={errorStyle}>⚠ {emailError}</p>}
        <button type="submit" disabled={loading} style={{ ...btnStyle, opacity: loading ? 0.6 : 1, marginTop: 24 }}>
          {loading ? 'Отправка...' : 'Отправить код'}
        </button>
      </form>
    </div>
  );
}

const backBtn = { background: 'none', color: 'var(--primary)', fontSize: 16, marginTop: 8, marginBottom: 40, cursor: 'pointer', padding: 0 };
const titleStyle = { fontSize: 28, fontWeight: 'bold', color: 'var(--primary)', marginBottom: 8 };
const subtitleStyle = { fontSize: 15, color: 'var(--text-light)', marginBottom: 24, lineHeight: 1.5 };
const labelStyle = { display: 'block', fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 6, marginTop: 8 };
const inputStyle = { display: 'block', width: '100%', background: 'var(--input-bg)', borderRadius: 12, padding: '12px 16px', fontSize: 15, color: 'var(--text)', border: '1.5px solid var(--border)', outline: 'none', marginBottom: 4 };
const errorStyle = { fontSize: 13, color: '#FF3B30', marginTop: 4 };
const btnStyle = { display: 'block', width: '100%', padding: 14, borderRadius: 14, background: 'var(--primary)', color: '#fff', fontSize: 16, fontWeight: 700 };
